import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/family/save_auto_refill
export const saveAutoRefill = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/family/save_auto_refill`, payload)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        reject(err.responseText)
      })
  })
}
